import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 供应商管理
 */
export default {
  path: 'supplier-manage',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '供应商管理',
    icon: 'icon-side_supplier_lib'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 供应商招募
    {
      path: 'recruit',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '供应商招募'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 招募列表
        {
          path: 'list',
          name: 'RecruitList',
          component: '/supplier-manage-views/recruit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招募列表',
            cache: true,
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 发布招募
        {
          path: 'order/:orderId?/create',
          name: 'RecruitForm',
          component: '/supplier-manage-views/recruit/form',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '发布招募',
            hidden: true,
            needFormKey: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 招募详情
        {
          path: 'order/:orderId/base-info',
          name: 'RecruitBaseInfo',
          component: '/supplier-manage-views/recruit/detail/progress/base-info',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招募详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 招募报名
        {
          path: 'order/:orderId/apply',
          name: 'RecruitApplyInfo',
          component: '/supplier-manage-views/recruit/detail/progress/apply',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招募报名',
            hidden: true,
            cache: true,
            pageComponentName: 'RecruitApplyInfo'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 报名审核
        {
          path: 'order/:orderId/tradeId/:tradeId/:type?',
          name: 'RecruitAuditDetail',
          component: '/supplier-manage-views/recruit/detail/progress/audit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '报名审核',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 招募结果
        {
          path: 'order/:orderId/result',
          name: 'RecruitResult',
          component: '/supplier-manage-views/recruit/detail/progress/result',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招募结果',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 更改招募信息
        {
          path: 'order/:orderId/content-change',
          name: 'RecruitContentChanges',
          component:
            '/supplier-manage-views/recruit/detail/changes/content-change',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '更改招募信息',
            hidden: true,
            needFormKey: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 供应商库
    {
      path: 'lib',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '供应商列表',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 供应商库列表
        {
          path: 'list',
          name: 'SupplierLibList',
          component: '/supplier-manage-views/supplier-lib',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '供应商库列表',
            cache: true,
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 供应商详情
        {
          path: 'supplier/:supplierId/list/:listedId/detail',
          name: 'SupplierLibDetail',
          component: '/supplier-manage-views/supplier-lib/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '供应商详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 共享记录
        {
          path: 'supplier/share-record',
          name: 'SupplierLibShareRecord',
          component: '/supplier-manage-views/supplier-lib/share-record',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '共享记录',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
